<template lang="pug">
.nivagation
  span.iconfont.pre(@click="prev") &#xe60d;
  span  {{current}} / {{total}}
  span.iconfont.next(@click="next")  &#xe602;
</template>

<script>
const Page = {
  props: ['total'],
  data () {
    return {
      current: 1
    }
  },
  mounted () {

  },
  components: {

  },
  computed: {

  },
  methods: {
    prev () {
      this.current--
      if (this.current === 0) this.current = this.total
      this.$emit('prev')
    },
    next () {
      if (this.current === this.total) {
        this.current = 1
      } else {
        this.current++
      }
      this.$emit('next')
    },
    auto () {
      if (this.current === this.total) {
        this.current = 1
      } else {
        this.current++
      }
    }
  }
}
export default Page
</script>

<style scoped lang="stylus">
.nivagation{
  user-select: none;
  position: fixed;
  display: inline;
  color: #fff;
  width: auto;
}
.iconfont{
  font-size: 24px;
  cursor: pointer;
}
@media (max-width: 720px) {
  .iconfont{
    font-size: 12px;/*no*/
  }
}
</style>



// WEBPACK FOOTER //
// page.vue?17aa54c4